@if (trustedBody(); as body) {
  <!--
    Render the admin-authored consent document verbatim (it carries its own card,
    copy and action buttons). Isolated sandbox: sandbox="allow-scripts" WITHOUT
    allow-same-origin → unique opaque origin that cannot read our cookies /
    localStorage / DOM, nor escape the frame. This is the trust boundary.
  -->
  <iframe
    #consentFrame
    class="w-full"
    style="height: 90vh; border: 0; display: block; border-radius: 8px"
    title="Consent details"
    [srcdoc]="body"
    sandbox="allow-scripts"
    referrerpolicy="no-referrer"
    loading="lazy"
  ></iframe>
} @else {
  <p class="p-4 m-0 text-sm text-gray-600">
    Consent details are currently unavailable.
  </p>
}
